module.exports = __webpack_public_path__ + "static/media/checked.3dc3e8c2.webp";